import { Typography, Box } from '@mui/material';
import { styled } from '@mui/system';

export const Container = styled(Box)(({ theme }) => ({
    backgroundColor: '#F5F5F5',
    minHeight: '100vh',
    width: '100%',
    maxWidth: '100%',
    overflowX: 'hidden',
    paddingBottom: '80px', // Add padding for the fixed navigation
}));

export const Title = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
    fontSize: '1.5rem',
    marginBottom: theme.spacing(3),
}));

export const RewardBanner = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    backgroundColor: '#FFF8E1',
    border: '1px solid #FFE082',
    color: '#8D6E00',
    borderRadius: 12,
    padding: '12px 16px',
    marginBottom: 24,
    fontWeight: 700,
    fontSize: '1rem',
    textAlign: 'center',
    boxShadow: '0 2px 8px rgba(240, 164, 0, 0.15)',
    '@media (max-width: 600px)': {
        fontSize: '0.88rem',
        padding: '10px 12px',
    }
});

// Separador entre os vencedores e as demais posições dentro da lista.
export const RankingDivider = styled(Box)({
    padding: '8px 16px',
    fontSize: '0.75rem',
    fontWeight: 600,
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    color: '#9e9e9e',
    backgroundColor: '#FAFAFA',
    borderTop: '1px solid #eee',
    borderBottom: '1px solid #eee',
});

export const RankingListContainer = styled(Box)({
    backgroundColor: 'white',
    borderRadius: 16,
    overflow: 'hidden',
    marginBottom: 32,
    width: '100%',
    boxSizing: 'border-box',
    boxShadow: '0 2px 12px rgba(0,0,0,0.05)',
});

export const ProgressSection = styled(Box)({
    marginBottom: 32,
    '@media (max-width: 600px)': {
        '& .MuiTypography-h6': {
            fontSize: '1rem'
        },
        '& .MuiTypography-body2': {
            fontSize: '0.8rem'
        }
    }
});

export const CallToAction = styled(Box)({
    textAlign: 'center',
    padding: 24,
    backgroundColor: 'white',
    borderRadius: 16,
    '@media (max-width: 600px)': {
        padding: 16,
        '& .MuiTypography-h6': {
            fontSize: '1.1rem'
        },
        '& .MuiTypography-body1': {
            fontSize: '0.9rem'
        }
    }
});
